function reviewChange() {
    let showReviewsStatus = false;

    let reviewStylingInterval = setInterval(reviewElement, 500);
    function stopStyling() {
        clearInterval(reviewStylingInterval);
    }

    function initGridItems() {
        document.querySelectorAll('.td-card-product .junip-product-summary-review-count').forEach(item => {
            let reviewCount = item.innerText.split("(")[1].split(")")[0];
            item.innerHTML = reviewCount + " Reviews";
        });
        showReviewsStatus = true;
    }

    function reviewElement() {
        if (document.querySelectorAll('.td-card-product .junip-product-summary-review-count').length > 0) {
            stopStyling();
            initGridItems();
        }
    }

    document.addEventListener('scroll', function () {
        if (!showReviewsStatus) {
            let heading = document.querySelector('.related-products__heading');
            if (heading) {
                if (window.innerHeight < heading.getBoundingClientRect().top) {
                    reviewElement();
                    showReviewsStatus = true;
                }
            }
        }
    });

    setTimeout(function () {
        stopStyling();
    }, 60000);
}

reviewChange();